import { ChangeDetectionStrategy, Component, ViewEncapsulation, inject } from '@angular/core';
import { TSTreeNode } from 'tsui';
import { TsPageSidenavConfig } from 'tsui/lib/ts-page/ts-page.component';
import { ReportTypeQueryParamValues } from 'app/modules/reports/reports.types';
import { Router } from '@angular/router';
import { reportBuilderListMenuItems } from '../reporting.constants';

@Component({
  selector: 'app-list-wrapper',
  templateUrl: './list-wrapper.component.html',
  styleUrls: ['./list-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ListWrapperComponent {
  readonly validReportTypes = [ReportTypeQueryParamValues.SingleObject, ReportTypeQueryParamValues.TimeSeries];

  readonly options$ = reportBuilderListMenuItems;
  readonly router = inject(Router);
  readonly sideNavConfig: TsPageSidenavConfig = {
    title: 'Views',
  };

  isActiveLeafNodeFn = (node: TSTreeNode): boolean => this.router.url.endsWith(node.link);
}
